// @flow

import FocusBody from 'components/FocusBody';
import * as React from 'react';
import View from 'components/View';
import { withCookies } from 'react-cookie';
import { homePath } from 'WebModule/app/routerPaths';
import LanguageSwitcher from 'WebModule/i18n/LanguageSwitcher';
import { injectIntl } from 'react-intl';
import FocusHeader from '../components/FocusHeader';
import FocusContent from '../components/FocusContent';
import { FocusPage } from '../components/Page';
import RegisterPage from './RegisterPage';
import { getAllowLanguageSwitch } from '../../../utils/i18n';

const styles = {
  focusContentWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  focusContent: {
    margin: '60px'
  },
  pageWrapper: {
    height: '100%',
    position: 'relative'
  },
  languageSwitcherStyles: {
    position: 'absolute',
    top: '10px',
    right: '10px',

    '& select': {
      color: 'silver'
    },

    '& svg': {
      color: 'silver'
    }
  }
};

const Focus = ({ cookies, history, intl }) => {
  const allowLanguageSwitcher = getAllowLanguageSwitch(cookies);

  return (
    <View style={styles.pageWrapper}>
      {allowLanguageSwitcher ? (
        <View style={styles.languageSwitcherStyles}>
          <LanguageSwitcher />
        </View>
      ) : null}

      <FocusPage>
        <View style={styles.focusContentWrapper}>
          <FocusContent style={styles.focusContent}>
            <FocusHeader
              onClose={() => {
                history.push(homePath);
              }}
            />
            <FocusBody>
              <View label={intl.formatMessage({ id: 'registration.new-customer' })}>
                <RegisterPage />
              </View>
            </FocusBody>
          </FocusContent>
        </View>
      </FocusPage>
    </View>
  );
};

export default injectIntl(withCookies(Focus));
